// instrumentation-client.js
import posthog from 'posthog-js';
import * as Sentry from "@sentry/react";

// Initialize Sentry if DSN is provided
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
      enableLogs: true,
    integrations: [
      // Send console.log, console.warn, and console.error to Sentry as logs
        Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
        Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
            colorScheme: "system",
            showEmail: false
    }),

    ],
  });
}


// Only initialize PostHog if keys are provided
if (import.meta.env.VITE_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',
    person_profiles: 'identified_only',
  });
}
